import { Types } from "./AppRoot";

function replaceHashPath(path: string) {
    const hashIndex = window.location.href.indexOf("#");
    const pathname = window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0);
    window.location.replace(pathname + "#" + path);
}
class Hash {
    // private isEdit: boolean;
    // private pop: any;
    constructor(history: any) {
        // window.onhashchange = this.hasChange.bind(this);
        let lastURL = document.URL;
        window.onhashchange = (event: any) => {
            if (!(window as any).HashChangeEvent) {
                // 兼容 ie8 - 11 等 （ie上没有 oldUrl/newUrl 等属性）
                Object.defineProperty(event, "oldURL", { enumerable: true, configurable: true, value: lastURL });
                Object.defineProperty(event, "newURL", { enumerable: true, configurable: true, value: document.URL });
                lastURL = document.URL;
            }
            if (!history.isEdit)
                this.hasChange(event, history.getLastRoute);
        };
    }
    get(lHash?: string) {
        const hash = lHash || window.location.hash;
        const index = hash.indexOf("?");
        const p = hash.substr(index + 1).split("&");
        const start = hash.indexOf("#/") === 0 ? 2 : 1;
        let h = hash.substring(start);
        const params = {};
        if (index > -1) {
            h = hash.substring(start, index);
        }
        p.map((item: any) => {
            const data = item.split("=");
            if (data[0]) {
                params[data[0]] = data[1];
            }
        });
        return { route: h, props: params };
    }

    hashChangeListener: any;

    registerHashChange(hashChange: any) {
        this.hashChangeListener = hashChange;
    }

    hasChange(ev: any, getLastRoute: any) {
        // if (this.isEdit) return;

        const newUrl = ev.newURL;
        const oldUrl = ev.oldURL;
        if (oldUrl.indexOf("#/") <= -1 || newUrl.indexOf("#/") <= -1) return;
        const oldL = this.get(`#/${oldUrl.split("#/")[1]}`);
        const newL = this.get(`#/${newUrl.split("#/")[1]}`);
        if (oldL.route !== newL.route && newUrl.indexOf(window.location.hash) > -1) {
            const upRoute = getLastRoute();
            if (!this.hashChangeListener) return;
            if (newL.route === upRoute.ename) {
            } else if (upRoute.ename === oldL.route) {
                if (oldL.props && oldL.props["init"] === "-1" && oldL.props["ncpage"] === "true") {
                    this.hashChangeListener(Types.StartPage, {
                        ename: newL.route,
                        props: { ...newL.props, init: -1, wback: true }
                    });
                } else {
                    this.hashChangeListener(Types.Back);
                }
            } else {
                this.hashChangeListener(Types.StartPage, { ename: newL.route, props: newL.props });
            }
        }
    }
    fromHash() {
        const params = window.location.hash ? window.location.hash.substr(1).split("&") : [],
            paramsObject = {};
        for (const i of params) {
            const a = i.split("=");
            paramsObject[a[0]] = decodeURIComponent(a[1]);
        }
        return paramsObject;
    }
    getHash(params: any) {
        let str = "";
        for (const p in params) {
            if (p && encodeURIComponent(params[p]) !== "undefined") {
                if (p !== "route") {
                    if (str.indexOf("?") <= -1) {
                        str = `${str}?${p}=${encodeURIComponent(params[p])}`;
                    } else {
                        str = `${str}&${p}=${encodeURIComponent(params[p])}`;
                    }
                } else {
                    str = encodeURIComponent(params[p]);
                }
            }
        }
        return str;
    }

    toHash(params: any) {
        let str = "";
        let changeHashFn = (path: string) => {
            window.location.hash = path;
        };
        if (params["wback"] === true) {
            // pc 不使用缓存页面方式的回退
            changeHashFn = replaceHashPath;
            delete params["wback"];
        }
        if (params["staticLinkType"] === true) {
            // 静态化跳转
            changeHashFn = replaceHashPath;
            delete params["staticLinkType"];
        }
        for (const p in params) {
            if (p && encodeURIComponent(params[p]) !== "undefined") {
                if (p !== "route") {
                    if (str.indexOf("?") <= -1) {
                        str = `${str}?${p}=${encodeURIComponent(params[p])}`;
                    } else {
                        str = `${str}&${p}=${encodeURIComponent(params[p])}`;
                    }
                } else {
                    str = params[p];
                }
            }
        }
        if (str.indexOf("/") !== 0) str = `/${str}`;
        changeHashFn(str);
    }

    add(newParams: any) {
        const params: any = this.fromHash();
        for (const p in newParams) {
            if (p) {
                params[p] = newParams[p];
            }
        }
        this.toHash(newParams);
    }
    remove(removeParams: any) {
        removeParams = typeof removeParams === "string" ? [removeParams] : removeParams;
        const params = this.fromHash();
        for (const i of removeParams.length) {
            if (i) {
                delete params[i];
            }
        }
        this.toHash(params);
    }
    clear() {
        this.toHash({});
    }
}

export default Hash;
